import { appState } from "./state";
import type { MediaItem } from "./types";

function safeName(m?: MediaItem): string {
  return String(m?.filename || "").replace(".enc", "").toLowerCase();
}

export function safeDateMs(m?: MediaItem): number {
  const v = m?.updatedAt || m?.addedAt || m?.uploadedAt || "";
  const ms = Date.parse(v);
  return Number.isFinite(ms) ? ms : 0;
}

function safeSize(m?: MediaItem): number {
  const n = Number(m?.size);
  return Number.isFinite(n) ? n : 0;
}

function safeType(m?: MediaItem): string {
  const fn = String(m?.filename || "").replace(".enc", "").toLowerCase();
  const extension = fn.split(".").pop() || "";
  const isVid = ["mp4", "webm", "mov", "avi"].includes(extension);
  return (isVid ? "video" : "image") + ":" + extension;
}

export function sortMediaInPlace(): void {
  const dirMul = appState.sortState.dir === "asc" ? 1 : -1;

  appState.media.sort((a, b) => {
    let av: string | number;
    let bv: string | number;

    switch (appState.sortState.key) {
      case "name":
        av = safeName(a);
        bv = safeName(b);
        break;
      case "size":
        av = safeSize(a);
        bv = safeSize(b);
        break;
      case "type":
        av = safeType(a);
        bv = safeType(b);
        break;
      case "date":
      default:
        av = safeDateMs(a);
        bv = safeDateMs(b);
        break;
    }

    if (typeof av === "number" && typeof bv === "number") {
      if (av === bv) {
        return safeName(a).localeCompare(safeName(b)) * dirMul;
      }
      return (av - bv) * dirMul;
    } else {
      const cmp = String(av).localeCompare(String(bv));
      if (cmp === 0) return safeDateMs(b) - safeDateMs(a);
      return cmp * dirMul;
    }
  });
}
